import React from "react"
import Paper from "material-ui/Paper"
import AccountBilling from "./AccountBilling"
import AccountUsers from "./AccountUsers/AccountUsers"
import AccountHierarchyDefinition from "./hierarchy_definitions/AccountHierarchyDefinition"
import AccountPositions from "./positions/AccountPositions"
import AccountSettings from "./AccountSettings"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import accountStore from "../../stores/AccountStore"

interface IProps {
    params: {
        accountId: string
        subpage: string
    }
}

const Account: React.SFC<IProps> = (props: IProps) => {
    document.title = `${strings.Account} | ${strings.Findd_Grandd_Central}`
    let contentPaper = null
    let pageTitle = ""
    const accountId = props.params.accountId
    switch (props.params.subpage) {
        case "Billing":
            contentPaper = <AccountBilling />
            pageTitle = strings.AccountActivity
            break
        case "Users":
            contentPaper = <AccountUsers />
            pageTitle = strings.Account_Users
            break
        case "HierarchyDefinitions":
            contentPaper = <AccountHierarchyDefinition accountId={accountId} />
            pageTitle = strings.Account_Hierarchy_Level_Definitions
            break
        case "Positions":
            contentPaper = <AccountPositions />
            pageTitle = accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel
                ? `Current ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel}`
                : strings.Account_Positions_Table_Header
            break
        case "Settings":
            contentPaper = <AccountSettings accountId={accountId} />
            pageTitle = strings.Account_Settings
            break
        default:
            break
    }

    return (
        <div className="page-container Account">
            <div className="page-container-parent">
                <Paper zDepth={1} className="page-paper" style={{ padding: props.params.subpage !== "Users" ? 20 : 0 }}>
                    {props.params.subpage !== "Users" && (
                        <div className="pageHeading" style={{ marginBottom: "20px" }}>
                            {pageTitle}
                        </div>
                    )}
                    {props.params.subpage !== "Hierarchy" && props.params.subpage !== "Settings" ? <Paper zDepth={0}>{contentPaper}</Paper> : contentPaper}
                </Paper>
            </div>
        </div>
    )
}

export default Account
